<template>
  <div>
    <div v-if="declarations && declarations.length === maxResults" class="alert alert-light alert-card-attached">
      Laetud {{maxResults}} värskemat kirjet, täpsusta otsingut
    </div>
    <div v-else-if="declarations && declarations.length" class="alert alert-light alert-card-attached">
      Laetud {{declarations.length}} kirjet
    </div>
    <table v-if="declarations && declarations.length" id="declarations-list" class="table table-centered table-sm table-hover table-expandable table-sticky mt-4">
      <thead>
        <tr>
          <th></th>
          <th>
            <b-form-checkbox v-model="allSelected" @change="toggleAll" title="Vali kõik"/>
          </th>
          <th></th>
          <th>Tolliviide</th>
          <th>Viitenumber</th>
          <th>Klient</th>
          <th>Aktsepteeritud</th>
          <th></th>
          <th class="text-center">Staatus</th>
          <th>Arv. maksud</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
      <template v-for="declaration in declarations">
        <tr :class="{'selected-row': declaration.selected, 'table-row-expanded': declaration.detailsVisible}" class="declaration">
          <td>
            <span v-if="declaration.isArchived" class="badge badge-secondary"> A </span>
          </td>
          <td :class="{'not-allowed': !declaration.invoiceCreationAllowed}">
            <b-form-checkbox v-model="declaration.selected" :value="true" :unchecked-value="false"
                             :disabled="!declaration.invoiceCreationAllowed" class="mr-0"/>
          </td>
          <td class="pl-0">
            <a href="" @click.prevent="toggleDetails(declaration)">
              <i class="mdi mdi-arrow-up-drop-circle" v-if="!declaration.detailsVisible"></i>
              <i class="mdi mdi-arrow-down-drop-circle" v-if="declaration.detailsVisible"></i>
            </a>
          </td>
          <td>
            <router-link :to="`/declarations/${declaration.id}`" class="declaration-details-link">
              {{declaration.customsReference}}
            </router-link>
          </td>
          <td>{{declaration.reference}}</td>
          <td>{{declaration.clientName}}</td>
          <td><span v-if="declaration.date">{{declaration.date | formatDate}}</span></td>
          <td>{{declaration.direction}}</td>
          <td><span :class="'badge badge-lg d-block badge-' + (declaration.requiresAttention ? 'danger' : 'light')">{{declaration.status}}</span></td>
          <td class="text-right" nowrap>{{declaration.totalTaxAmount ? declaration.totalTaxAmount + ' €' : ''}}</td>
          <td class="p-0">
            <router-link class="btn btn-sm btn-link text-nowrap" :to="`/invoices/${declaration.invoiceId}`" v-if="declaration.numInvoices === 1">
              <i class="mdi mdi-receipt"></i>
              Vaata arvet
            </router-link>
            <button class="btn btn-sm btn-link text-nowrap" @click="toggleDetails(declaration, true)" v-if="declaration.numInvoices > 1">
              <i class="mdi mdi-chevron-down" v-if="!declaration.detailsVisible"></i>
              <i class="mdi mdi-chevron-up" v-if="declaration.detailsVisible"></i>
              Vaata arveid
            </button>
            <submit-button class="btn btn-sm btn-link" variant="link" @click="makeInvoice(declaration)" v-if="declaration.invoiceCreationAllowed">
              <i class="mdi mdi-plus"></i> Koosta arve
            </submit-button>
            <button class="btn btn-sm btn-link" @click="changeClient(declaration)" v-if="!declaration.clientId">
              <i class="mdi mdi-account-multiple"></i> Määra klient
            </button>
          </td>
        </tr>
        <tr v-if="declaration.detailsVisible" class="table-row-expanded-content">
          <td colspan="10">
            <declaration-invoicing-details :declarationId="declaration.id"/>
          </td>
        </tr>
      </template>
      </tbody>
    </table>

    <div v-else-if="declarations" class="alert alert-light alert-card-attached">
      <i class="mdi mdi-information mr-1"></i>Deklaratsioone ei leitud
    </div>

    <div v-else class="alert alert-light d-flex align-items-center alert-card-attached">
      <div class="spinner-border spinner-border-sm mr-1"></div>
      <span>Laeme andmeid...</span>
    </div>

    <div v-if="this.selectedCount" class="fixed-bottom-toolbar">
      <div class="p-2">
        <button type="button" class="btn btn-sm btn-link btn-outline-light">
          {{this.selectedCount}} valitud
        </button>
        <button type="button" class="btn btn-sm btn-outline-dark ml-2" @click="clearSelection">
          <i class="mdi mdi-delete"></i> Tühista valik
        </button>
        <submit-button type="button" class="btn btn-sm ml-5" variant="primary" @click="createInvoiceFromSelection">
          <i class="mdi mdi-plus"></i>Koosta arve <span class="muted"></span>
        </submit-button>
        <submit-button type="button" class="btn btn-sm ml-1" variant="primary" @click="addSelectionToInvoice">
          <i class="mdi mdi-plus"></i>Lisa arvele<span class="muted"></span>
        </submit-button>

        <strong v-if="showMultipleClientsWarning" class="ml-4 text-danger">
          <i class="mdi mdi-alert-circle"></i>
          Erinevate klientide deklaratsioonid
        </strong>

      </div>
    </div>

    <modal ref="addDeclarationsToInvoiceModal" size="lg" title="Vali arve" @ok="loadDeclarations()">
      <add-declarations-to-invoice :declaration-ids="data" slot-scope="{close, visible, data, cancel}" @done="close" @cancel="cancel" v-if="visible"/>
    </modal>

    <modal ref="changeClientModal" size="lg" title="Määra klient" @ok="loadDeclarations()">
      <change-client :declaration="data" slot-scope="{close, visible, data}" @done="close" v-if="visible"/>
    </modal>
  </div>
</template>

<script>
import gateway from '@/services/gateway'
import Vue from 'vue'
import DeclarationInvoicingDetails from '@/components/declaration/DeclarationInvoicingDetails'
import AddDeclarationsToInvoice from '@/components/declaration/AddDeclarationsToInvoice'
import ChangeClient from '@/components/declaration/ChangeClient'
import Modal from '@/components/Modal'
import SubmitButton from '../SubmitButton'

export default {
  components: {DeclarationInvoicingDetails, AddDeclarationsToInvoice, Modal, ChangeClient, SubmitButton},
  props: ['filter'],
  data() {
    return {
      maxResults: 1000,
      declarations: null,
      selectedCount: 0,
      showMultipleClientsWarning: false,
      allSelected: false
    }
    },
    created() {
      this.loadDeclarations()
    },
    watch: {
      filter: {
        handler() {
          this.loadDeclarations()
        },
        deep: true
      },
      declarations: {
        handler(after) {
          if (!after) after = []
          const selectedRows = after.filter(d => d.selected)
          if (this.selectedCount !== selectedRows.length) {
            this.allSelected = false
            this.selectedCount = selectedRows.length
            const uniqueClients = this.distinctClients(selectedRows)
            this.showMultipleClientsWarning = Object.keys(uniqueClients).length > 1
          }
        },
        deep: true
      }
    },
    methods: {
      distinctClients(selectedRows) {
        let uniqueClients = {}
        selectedRows.forEach(row => {
          uniqueClients[row.clientId] = row.clientId
        })
        return uniqueClients
      },
      loadDeclarations() {
        this.declarations = null
        const params = {
          maxResults: this.maxResults,
          clientId: this.filter.clientId,
          status: this.filter.status,
          direction: this.filter.direction,
          from: this.filter.dateRange.from,
          until: this.filter.dateRange.until,
          referencePrefix: this.filter.referencePrefix,
          query: this.filter.query,
          invoiceNumberPrefix: this.filter.invoiceNumberPrefix
        }
        gateway.get('/declarations', {params}).then(r => {this.declarations = r.data.map(d => {d.selected = false; return d})})
      },
      makeInvoice(declaration) {
        gateway.post('/invoices/create', {declarationIds: [declaration.id]})
          .then(r => this.$router.push(`/invoices/${r.data}`))
          .catch(r => this.$notifications.error(r.response.data.key))
      },
      clearSelection() {
        this.toggleAll(false)
      },
      submitDeclarationsToServer() {
        let selectedIds = this.getSelectedIds()
        gateway.post('/invoices/create', {declarationIds: selectedIds})
          .then(r => this.$router.push(`/invoices/${r.data}`))
          .catch(r => this.$notifications.error(r.response.data.key))
      },
      createInvoiceFromSelection() {
        if (this.showMultipleClientsWarning) {
          this.$confirm("Valisite erinevad kliendid. Olete kindel?", () => this.submitDeclarationsToServer())
        } else {
          this.submitDeclarationsToServer()
        }
      },
      getSelectedIds: function () {
        return this.declarations.filter(d => d.selected).map(d => d.id)
      },
      addSelectionToInvoice() {
        let selectedIds = this.getSelectedIds()
        if (this.showMultipleClientsWarning) {
          this.$confirm("Valisite erinevad kliendid. Olete kindel?", () => this.$refs.addDeclarationsToInvoiceModal.show(selectedIds))
        } else {
          this.$refs.addDeclarationsToInvoiceModal.show(selectedIds)
        }
      },
      toggleDetails(declaration) {
        if (declaration.detailsVisible === undefined)
          Vue.set(declaration, 'detailsVisible', false)

        declaration.detailsVisible = !declaration.detailsVisible
      },
      toggleAll(checked) {
        this.declarations.forEach(d => {if (d.invoiceCreationAllowed) d.selected = checked})
        this.selectedCount = this.declarations.filter(d => d.selected).length
      },
      changeClient(declaration) {
        this.$refs.changeClientModal.show(declaration)
      }
    }
  }
</script>
